// ============================================================================
// FORD-FULKERSON - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'ford-fulkerson',
  name: 'Ford-Fulkerson',
  category: 'Graphs',
  complexity: {
    time: 'O(E * max_flow)',
    space: 'O(V²)'
  },
  description: 'A method for computing maximum flow in a flow network. It repeatedly finds augmenting paths from source to sink and augments flow along them until no more augmenting paths exist.'
};
